import { ITransaction, TransactionSource } from "../../../types";
import { ActionReason } from "../../../api/graphql/schema.generated";

export const INCOMING_TRANSACTION_REASONS = [
  { label: "Hinweis auf KU fehlt", value: ActionReason.SMALL_BUSINESS_MISSING },
  {
    label: "Steuersatz falsch Nebenleistungen",
    value: ActionReason.WRONG_TAXRATE_ANCILLARY_SERVICE,
  },
  {
    label: "Hinweis auf steuerfreie Umsätze fehlt",
    value: ActionReason.MISSING_TAX_EXEMPT_SALES,
  },
  { label: "Kein ermäßigter Steuersatz", value: ActionReason.NO_REDUCED_TAX },
  {
    label: "Reverse Charge Hinweis fehlt",
    value: ActionReason.REVERSE_CHARGE_MISSING,
  },
  { label: "Leistung nicht steuerbefreit", value: ActionReason.OBLIGED_TAXES },
  { label: "Betrag falsch", value: ActionReason.INCOMING_AMOUNT_WRONG },
  { label: "USt-ID fehlt", value: ActionReason.VAT_ID_MISSING },
  { label: "KU weist 19% aus", value: ActionReason.SMALL_BUSINESS_VAT },
  {
    label: "Keine gültige Ausgangsrechnung",
    value: ActionReason.WRONG_OUTGOING_INVOICE,
  },
  { label: "Belege hochladen", value: ActionReason.INVOICE_REQUIRED },
  {
    label: "Elektronische Dienstleistung",
    value: ActionReason.ELECTRONIC_SERVICES,
  },
];

export const OUTGOING_TRANSACTION_REASONS = [
  { label: "Ungültiger Beleg", value: ActionReason.INVALID_RECEIPT },
  {
    label: "Bewirtungsbeleg fehlt",
    value: ActionReason.NO_HOSPITALITY_RECEIPT,
  },
  {
    label: "Betrag auf Beleg falsch",
    value: ActionReason.OUTGOING_AMOUNT_WRONG,
  },
  {
    label: "Reverse Charge Information",
    value: ActionReason.REVERSE_CHARGE_INFORMATION,
  },
  { label: "Rechnung über 250€", value: ActionReason.INVOICE_ABOVE_250 },
  { label: "Rechnung unter 250€", value: ActionReason.INVOICE_BELOW_250 },
  { label: "Unklare Ausgabe", value: ActionReason.UNCLEAR_EXPENSE },
  { label: "Externes Bankkonto", value: ActionReason.EXTERNAL_BANK_ACCOUNT },
  { label: "Neuer Pkw", value: ActionReason.CAR_USAGE },
];

export const ALL_TRANSACTION_REASONS = [
  ...INCOMING_TRANSACTION_REASONS,
  ...OUTGOING_TRANSACTION_REASONS,
];

export const EMPTY_TRANSACTION: ITransaction = {
  email: "",
  firstName: "",
  lastName: "",
  id: "",
  type: "",
  amount: 0,
  valutaDate: "",
  name: "",
  iban: "",
  description: "",
  foreignCurrency: "",
  businessTypeComment: "",
  personalNote: null,
  assets: [],
  verified: false,
  source: TransactionSource.SOLARIS,
  currency: "EUR",
};
